var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.35,
    stroke: "white",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24219 6.84629C7.24219 6.42636 7.58261 6.08594 8.00254 6.08594V6.08594C8.42247 6.08594 8.76289 6.42636 8.76289 6.84629V11.8429C8.76289 12.2628 8.42247 12.6032 8.00254 12.6032V12.6032C7.58261 12.6032 7.24219 12.2628 7.24219 11.8429V6.84629Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76084 4.16389C8.76084 4.58382 8.42042 4.92424 8.00049 4.92424C7.58056 4.92424 7.24014 4.58382 7.24014 4.16389C7.24014 3.74396 7.58056 3.40354 8.00049 3.40354C8.42042 3.40354 8.76084 3.74396 8.76084 4.16389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation2);
export default __webpack_public_path__ + "static/media/information2.027a1b5e663f4e200f87ef882708ca1e.svg";
export { ForwardRef as ReactComponent };